export class EnumHelper {
  public static getEnumKeyByValue(enumType: any, value: any) {
    return Object.keys(enumType).find((key) => enumType[key] === value);
  }
}
